import fetch from "isomorphic-unfetch"
import { CartValidationState } from "../checkout/state/CartValidationState"
import { cartApiUrl } from "../Config"

export class UnfulfillableLineItem {
  public sku: string
  public availableQuantity: number

  constructor(sku: string, availableQuantity: number) {
    this.sku = sku
    this.availableQuantity = availableQuantity
  }
}

export class CartValidationResponse {
  public status: CartValidationState
  public unfulfillableLineItems: UnfulfillableLineItem[]

  constructor(
    status: CartValidationState,
    unfulfillableLineItems: UnfulfillableLineItem[]
  ) {
    this.status = status
    this.unfulfillableLineItems = unfulfillableLineItems
  }
}

export const useCartValidationApi = () => {
  async function extractUnfulfillableItems(response: Response) {
    const data = await response.json()
    return data.lineItems.map(it => {
      return new UnfulfillableLineItem(it.sku, it.availableQuantity)
    })
  }

  return {
    validateCart: async (cartId: string): Promise<CartValidationResponse> => {
      const response = await fetch(`${cartApiUrl(cartId)}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      })
      switch (response.status) {
        case 204:
          return Promise.resolve(
            new CartValidationResponse(CartValidationState.VALID, [])
          )
        case 409:
          const unfulfillableItems = await extractUnfulfillableItems(response)
          return Promise.resolve(
            new CartValidationResponse(
              CartValidationState.UNFULFILLABLE_CART,
              unfulfillableItems
            )
          )
        case 404:
          return Promise.resolve(
            new CartValidationResponse(CartValidationState.CART_NOT_FOUND, [])
          )
        case 504:
          return Promise.resolve(
            new CartValidationResponse(
              CartValidationState.UNABLE_TO_VERIFY_STOCK,
              []
            )
          )
        default:
          return Promise.resolve(
            new CartValidationResponse(CartValidationState.ERROR, [])
          )
      }
    }
  }
}
